<template>
  <div id="bjzc-home">
    <HomeBanner />
    <HomeService />
    <HomeTeam />
    <HomeIntroduction />
    <HomeNews />
  </div>
</template>

<script>
import HomeBanner from '../components/HomeBanner.vue'
import HomeService from '../components/HomeService.vue'
import HomeTeam from '../components/HomeTeam.vue'
import HomeIntroduction from '../components/HomeIntroduction.vue'
import HomeNews from '../components/HomeNews.vue'

export default {
  name: 'Home',
  components: { HomeBanner, HomeService, HomeTeam, HomeIntroduction, HomeNews }
}
</script>

<style lang="scss">
#bjzc-home {
}
</style>
